import React, { useEffect, useState, useContext, useRef } from 'react';
import $ from 'jquery';
import { GetCoockie, ValidateQty, shopping_cart_session_id, CheckSession, DefaultImage, KImageURL, FormatCurrency, GetShoppingCart } from "../GlobalScript";
import { ShoppingCartContext, ShoppingCartProvider } from '../dealer/ShoppingCartContext';
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import Button from 'react-bootstrap/Button';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import PulseLoader from "react-spinners/PulseLoader";
import { useTranslation, Trans } from 'react-i18next';

const generateInitialState = (numRows, initialValues) => {
    let initialState = Array.from({ length: numRows }, () => ({ sku: '', qty: '', memo: '' }));

    if (initialValues && initialValues.length <= numRows) {
        let idx = 0;
        initialValues.forEach(element => {
            initialState[idx].sku = element.sku;
            initialState[idx].qty = element.qty;
            initialState[idx].memo = element.memo;
        });
    }
    return initialState;
}

const BULK_BATCH_SIZE = 50;

const buildBulkBatchStatuses = (totalRecords) => {
    const total = Number(totalRecords) || 0;
    const statuses = [];

    for (let start = 1; start <= total; start += BULK_BATCH_SIZE) {
        const end = Math.min(start + BULK_BATCH_SIZE - 1, total);

        statuses.push({
            batchNumber: Math.floor((start - 1) / BULK_BATCH_SIZE) + 1,
            start,
            end,
            status: 'pending'
        });
    }

    return statuses;
};

const normalizeBulkPreviewItems = (items) => {
    if (!Array.isArray(items)) {
        return [];
    }

    return items.map((item, index) => ({
        lineNumber: index + 1,
        sku: item?.sku ?? item?.kdSku ?? '',
        qty: item?.qty ?? item?.kdQty ?? 0,
        memo: item?.vin ?? item?.memo ?? item?.kdMemo ?? ''
    }));
};

const ItemInquiry = ({ show, handleClose, handleSelectedItems, initialValues, orderType, setOrderType, autoSubmit, bulkLoadData, fromImport }) => {

    const { t } = useTranslation();
    const numRows = 10;

    const [rows, setRows] = useState(generateInitialState(numRows, initialValues));
    const [searchItems, setSearchItems] = useState(false);
    const [selectMode, setSelectMode] = useState(true);
    const [selectAll, setSelectAll] = useState(false);
    const [SKUItems, setSKUItems] = useState(new Map());
    const [AddSKUError, setAddSKUError] = useState([]);
    const [ItemsSubtotal, setItemsSubtotal] = useState(0);
    const [SelectedSKUs, setSelectedSKUs] = useState(new Set());
    const [ShowAddToOrder, setShowAddToOrder] = useState(false);
    const [SubstitutionSkus, setSubstitutionSkus] = useState(null);
    //const [BulkData, setBulkData] = useState(bulkLoadData);
    const [BulkData, setBulkData] = useState(null);
    const [pop, setPop] = useState(false);
    const [Typing, setTyping] = useState(false);
    const [showModelModal, setShowModelModal] = useState(false);
    const [alerts, setAlerts] = useState([]);
    const [AlertLTL, setAlertLTL] = useState(false);
    const [alertPk, setAlertPk] = useState(false);
    const [AlertFactorCount, setAlertFactorCount] = useState(0);
    const [alertRecallItem, setAlertRecallItem] = useState(0);
    const [AlertBOCount, setAlertBOCount] = useState(0);
    const [Models, setModels] = useState(null);
    const [SelectedItemForModels, setSelectedItemForModels] = useState(null);
    const [localFromImport, setLocalFromImport] = useState(fromImport ? fromImport : false);
    const [invalidSkus, setInvalidSkus] = useState(new Set());
    const [isDealer, setIsDealer] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [bulkProcessingCount, setBulkProcessingCount] = useState(0);
    const [bulkImportPreview, setBulkImportPreview] = useState(null);
    const [bulkImportStage, setBulkImportStage] = useState('idle');
    const [bulkBatchStatuses, setBulkBatchStatuses] = useState([]);
    const [bulkResultsStarted, setBulkResultsStarted] = useState(false);

    const inputRefs = useRef([]);
    const bulkRunRef = useRef(0);
    const bulkAbortControllerRef = useRef(null);
    const bulkLoadingMessageRef = useRef(null);
    const firstBatchAutoScrolledRef = useRef(false);
    const { shoppingCart, setShoppingCart} = useContext(ShoppingCartContext);
    const handlePop = () => setPop(true);
    const handleClosePop = () => {
        setPop(false);
    }

    const handleItemInquiryClose = () => {
        if (localFromImport && bulkImportStage === 'processing') {
            const confirmed = window.confirm(
                'Are you sure you want to cancel IMPORT ORDER?'
            );

            if (!confirmed) {
                return;
            }

            bulkRunRef.current += 1;
            bulkAbortControllerRef.current?.abort();
            bulkAbortControllerRef.current = null;
            setPop(false);
            setBulkProcessingCount(0);
            setBulkImportStage('finished');
        }

        handleClose();
    }

    const handleModelModalShow = (itemNum) => {
        GetModels(itemNum);
        setShowModelModal(true);
    }

    const modalBody = document.querySelector('.modal-body');
    const results = document.getElementById('itemInquiryResults');

    const GetModels = async (itemnum) => {
        CheckSession();
        const response = await fetch("kdealer/GetModels/" + itemnum);
        if (response.status !== 200) {
            return;
        }
        const js = await response.json();
        const grouped = Object.groupBy(js.models, ({ year }) => year);
        const sortedGroups = Object.entries(grouped)
            .sort(([groupA], [groupB]) => groupB.localeCompare(groupA))
            .map(([group, models]) => {
                models.sort((a, b) => a.label - b.label);
                return { group, models };
            });
        setSelectedItemForModels({ itemNum: js.itemNum, itemName: js.itemName })
        console.log(sortedGroups);
        setModels(sortedGroups);
    }
    const handleModelModalClose = () => setShowModelModal(false);

    useEffect(() => {
        setLocalFromImport(fromImport);
    }, [fromImport])

    useEffect(() => {
        resetItems();
        setRows(generateInitialState(numRows, initialValues));
        if (initialValues && initialValues.length > numRows) {
            setBulkData(initialValues);
        }
        setSearchItems(true);
    }, [initialValues]);

    useEffect(() => {
        if (bulkLoadData && bulkLoadData.bulkImportKey) {
            const previewItems = normalizeBulkPreviewItems(
                bulkLoadData.items ?? bulkLoadData.importedItems
            );

            const totalItems = previewItems.length > 0
                ? previewItems.length
                : Number(bulkLoadData.totalItems) || 0;

            bulkRunRef.current += 1;
            bulkAbortControllerRef.current?.abort();
            bulkAbortControllerRef.current = null;

            resetItems();
            setBulkData(null);
            setBulkImportPreview({
                ...bulkLoadData,
                totalItems,
                items: previewItems
            });
            setBulkImportStage('preview');
            setBulkBatchStatuses([]);
            setBulkResultsStarted(false);
            firstBatchAutoScrolledRef.current = false;
            setBulkProcessingCount(0);
            setPop(false);
            setLocalFromImport(true);
        } else if (Array.isArray(bulkLoadData) && bulkLoadData.length > 0) {
            setBulkImportPreview({
                bulkImportKey: 0,
                totalItems: bulkLoadData.length,
                items: normalizeBulkPreviewItems(bulkLoadData)
            });
            setBulkImportStage('preview');
            setBulkBatchStatuses([]);
            setBulkResultsStarted(false);
            firstBatchAutoScrolledRef.current = false;
            setBulkProcessingCount(0);
            setPop(false);
            setLocalFromImport(true);
        }

        return () => {
            bulkRunRef.current += 1;
            bulkAbortControllerRef.current?.abort();
            bulkAbortControllerRef.current = null;
        };
    }, [bulkLoadData]);

    useEffect(() => {
        if (BulkData && BulkData.length > 0 &&
            !localFromImport) {
            GetSKUDetail(BulkData);
        }
    }, [BulkData, localFromImport]);

    useEffect(() => {
        if (autoSubmit && initialValues.length > 0 && !Typing) {
            AddSkuClick();
            setTyping(false);
        }
    }, [rows]);

    useEffect(() => {
        setShowAddToOrder(SelectedSKUs.size > 0);
    }, [SelectedSKUs.size]);

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const newRows = [...rows];
        newRows[index][name] = value;
        if (name === "qty") {
            let newQty = ValidateQty(value);
            newRows[index][name] = newQty;
        } else if (name === "sku") {
            newRows[index][name] = value;
        } else if (name === "memo") {
            newRows[index][name] = value.toUpperCase();
        }
        setRows(newRows);
        setTyping(true);
    };

    const resetItems = () => {
        setRows(generateInitialState(numRows));
        setSKUItems(new Map());
        setShowAddToOrder(false);
        setAddSKUError([]);
        setInvalidSkus(new Set());
        setErrorMessage('');
    }

    useEffect(() => {
        if (show) {
            setErrorMessage('');
        } else if (show && !initialValues) {
            resetItems();
        } else {
            bulkRunRef.current += 1;
            bulkAbortControllerRef.current?.abort();
            bulkAbortControllerRef.current = null;
            setPop(false);
        }
    }, [show]);

    const calculateSelectedItemsSubtotal = (selectedSkus, skuItems) => {
        let subtotal = 0;

        selectedSkus.forEach(key => {
            const item = skuItems.get(key)?.item;

            if (!item || (item.itemStaCode !== "1" && item.itemStaCode !== "2")) {
                return;
            }

            const quantity = (Number(item.qty) || 0) + (Number(item.boCnt) || 0);
            const dealerPrice = Number(item.dealerPrice) || 0;

            subtotal += quantity * dealerPrice;
        });

        return Number(subtotal.toFixed(2));
    };

    const handleSelectItem = (e) => {
        const sku = e.target.id.substring(5);
        const set = new Set(SelectedSKUs);

        if (e.target.checked) {
            set.add(sku);
        } else {
            set.delete(sku);
        }

        if (set.size < SelectedSKUs.size) {
            setSelectAll(false);
        }

        setSelectedSKUs(set);
    }

    useEffect(() => {
        setItemsSubtotal(
            calculateSelectedItemsSubtotal(SelectedSKUs, SKUItems)
        );
    }, [SelectedSKUs, SKUItems]);

    const handleSubmit = (event) => {
        if (localFromImport && bulkImportStage === 'processing') {
            return;
        }

        let skuObjs = [];

        const alerts = [
            AlertFactorCount > 0 && { type: 'packQuantity' },
            AlertBOCount > 0 && { type: 'backorder' },
            AlertLTL && { type: 'ltlShipping' },
            SubstitutionSkus.length > 0 && { type: 'substitutions' }
        ].filter(Boolean);

        if (localFromImport) {
            CheckSession();

            const bulkItems = [];

            SelectedSKUs.forEach(rowKey => {
                const selected = SKUItems.get(rowKey);

                if (typeof rowKey !== 'string' ||
                    !rowKey.startsWith('bulk_') ||
                    !selected?.item ||
                    !(selected.item.qtyOrdered > 0) ||
                    (selected.item.itemStaCode !== '1' &&
                        selected.item.itemStaCode !== '2')) {
                    return;
                }

                bulkItems.push({
                    ...selected,
                    rowKey,
                    item: {
                        ...selected.item,
                        new: false
                    }
                });
            });

            if (bulkItems.length === 0 || !handleSelectedItems) {
                return;
            }

            handleSelectedItems({
                items: bulkItems,
                alerts
            }, false);

            setBulkData(null);
            resetItems();
            setLocalFromImport(false);
            handleClose();
            return;
        }
        // SelectedSKUs.forEach(value => {
        //     var $checkbox = $(`[id="check${value}"]`);
        //     if ($checkbox.length > 0 && $checkbox.prop('checked')) {
        //         skuObjs.push(SKUItems.get(value));
        //     }
        // });
        // if (skuObjs.length === 0) {
        //     return;
        // }
        CheckSession();
        const user = GetCoockie();
        const crrMap = new Map();
        let orderType = null;
        let dealerID = user.dealerID;
        let kCode = '';
        let orderName = '';
        const cart = GetShoppingCart(shoppingCart);
        if (cart && cart.orderType) {
            orderType = cart.orderType;
        }
        if (cart && cart.dealerID) {
            dealerID = cart.dealerID;
        }
        if (cart && cart.kCode) {
            kCode = cart.kCode;
        }
        if (cart && cart.orderName) {
            orderName = cart.orderName;
        }
        const arr = [];
        if (cart && cart.items) {
            cart.items.forEach(element => {
                const itmNum = element.item.distitemNbr.replaceAll('-', '');
                const cleanID = itmNum + (element.item.vin === '' ? '' : ('|' + element.item.vin));
                // if (!crrMap.has(cleanID) && element.item.qtyOrdered > 0) {
                //     if (itmNum === crrPartNum && element.item.vin === partMemo) {
                //         let copy = { ...element };
                //         copy.item.new = true;
                //         copy.item.qtyOrdered += qty;
                //         copy.item.qty += qty;
                //         crrMap.set(cleanID, copy);
                //         arr.push(copy);
                //         newQty = copy.item.qtyOrdered;
                //     } else {
                //         crrMap.set(cleanID, element);
                //         arr.push(element);
                //     }

                // }
                if (!crrMap.has(cleanID) && element.item.qtyOrdered > 0) {
                    crrMap.set(cleanID, element);
                    //arr.push(element);
                }

            });
        }
       
        SelectedSKUs.forEach(value => {
            var $checkbox = $(`[id="check${value}"]`);
            if ($checkbox.length > 0 && $checkbox.prop('checked')) {
                //skuObjs.push(SKUItems.get(value));
                const element = SKUItems.get(value);
                const itmNum = element.item.distitemNbr.replaceAll('-', '');
                const cleanID = itmNum + (element.item.vin === '' ? '' : ('|' + element.item.vin));
                if (!crrMap.has(cleanID) && element.item.qtyOrdered > 0) {
                    // if (itmNum === crrPartNum && element.item.vin === partMemo) {
                    //     let copy = { ...element };
                    //     copy.item.new = true;
                    //     copy.item.qtyOrdered += qty;
                    //     copy.item.qty += qty;
                    //     crrMap.set(cleanID, copy);
                    //     arr.push(copy);
                    //     newQty = copy.item.qtyOrdered;
                    // } else {
                    //     crrMap.set(cleanID, element);
                    //     arr.push(element);
                    // }
                    crrMap.set(cleanID, element);
                    //skuObjs.push(element);
                    //arr.push(element);
                }
                else if (crrMap.has(cleanID) && element.item.qtyOrdered > 0) {
                    let copy = { ...element };
                    copy.item.new = true;
                    copy.item.qtyOrdered += element.item.qtyOrdered;
                    copy.item.qty += element.item.qtyOrdered;
                    crrMap.set(cleanID, copy);
                    //skuObjs.push(copy);
                    //arr.push(copy);
                }
            }
        });
   
        for (const [key, value] of crrMap) {
            skuObjs.push(value);
        }
        if (skuObjs.length === 0) {
            return;
        }
        if (handleSelectedItems) {
            handleSelectedItems({ items: skuObjs, alerts: alerts, orderType: orderType, kCode: kCode, orderName: orderName }, false);
            //handleSelectedItems(skuObjs, AccSubtotal);
            //if (UpdateContextFromOutside) {
            //    UpdateContextFromOutside(skuObjs);
            //}
        }

        setBulkData(null);
        resetItems();
        if (fromImport) {
            setLocalFromImport(false);
        }
        handleClose();
        //window.location.reload();
    }

    const appendBulkItems = (processedItems) => {
        if (!Array.isArray(processedItems) || processedItems.length === 0) {
            return;
        }

        setBulkResultsStarted(true);

        const itemsToAppend = new Map();
        const selectedToAppend = new Set();
        const substitutionsToAppend = [];
        const invalidToAppend = new Set();

        let subtotalToAppend = 0;
        let factorCountToAppend = 0;
        let backorderCountToAppend = 0;
        let recallCountToAppend = 0;
        let hasLtl = false;
        let hasPackageAlert = false;

        processedItems.forEach(processedItem => {
            if (!processedItem || !processedItem.item) {
                return;
            }

            const item = processedItem.item;
            const addInfo = processedItem.addInfo || {};
            const rowKey = `bulk_${processedItem.bulkImportItemKey}`;

            itemsToAppend.set(rowKey, {
                item,
                addInfo,
                rowKey
            });

            if (item.itemStaCode === "1" || item.itemStaCode === "2") {
                selectedToAppend.add(rowKey);
                const quantity = (Number(item.qty) || 0) + (Number(item.boCnt) || 0);
                subtotalToAppend += quantity * (Number(item.dealerPrice) || 0);
            }

            if (item.substitutedSKU) {
                substitutionsToAppend.push(
                    `${item.substitutedSKU} is substituted by ${item.distitemNbr}`
                );
            }

            if (item.ltl === true) {
                hasLtl = true;
            }

            if (item.pk === true) {
                hasPackageAlert = true;
            }

            if (item.factorAlert === true) {
                factorCountToAppend += 1;
            }

            if (item.boCnt > 0) {
                backorderCountToAppend += 1;
            }

            if (item.recallItemCode === "QR" ||
                item.recallItemCode === "QV") {
                recallCountToAppend += 1;
            }

            if (item.errorMsg?.toUpperCase().includes("invalid") ||
                item.itemStaCode === "4" ||
                item.recallItemCode === "QR" ||
                item.recallItemCode === "QV") {
                const normalizedItem = item.distitemNbr
                    ?.toUpperCase()
                    .replaceAll('-', '');

                if (normalizedItem) {
                    invalidToAppend.add(normalizedItem);
                }
            }
        });

        setSKUItems(previousItems => {
            const nextItems = new Map(previousItems);

            itemsToAppend.forEach((value, key) => {
                nextItems.set(key, value);
            });

            return nextItems;
        });

        setSelectedSKUs(previousSelected => {
            const nextSelected = new Set(previousSelected);

            selectedToAppend.forEach(key => {
                nextSelected.add(key);
            });

            return nextSelected;
        });

        setInvalidSkus(previousInvalid => {
            const nextInvalid = new Set(previousInvalid);

            invalidToAppend.forEach(sku => {
                nextInvalid.add(sku);
            });

            return nextInvalid;
        });

        setItemsSubtotal(previousSubtotal =>
            previousSubtotal + subtotalToAppend
        );

        setAlertFactorCount(previousCount =>
            previousCount + factorCountToAppend
        );

        setAlertBOCount(previousCount =>
            previousCount + backorderCountToAppend
        );

        setAlertRecallItem(previousCount =>
            previousCount + recallCountToAppend
        );

        setAlertLTL(previousValue => previousValue || hasLtl);
        setAlertPk(previousValue =>
            previousValue || hasPackageAlert
        );

        setSubstitutionSkus(previousValues => [
            ...(previousValues || []),
            ...substitutionsToAppend
        ]);

        if (processedItems[0]?.item) {
            setIsDealer(processedItems[0].item.isDealer);
        }
    }

    const requestBulkImportBatch = async (
        bulkImportKey,
        batchNumber,
        isFallback,
        isFinalRetry,
        subBatchNumber,
        user,
        options = {}
    ) => {
        const requestBody = {
            bulkImportKey,
            batchNumber,
            isFallback,
            isFinalRetry,
            subBatchNumber,
            processPending: options.processPending === true,
            pendingBatchSize:
                Number(options.pendingBatchSize) || 0,
            afterItemKey:
                Number(options.afterItemKey) || 0,
            finalizePending: options.finalizePending === true,
            orderType: orderType ? orderType.toString() : '',
            dealerID: user.dealerID,
            userKey: user.userKey
        };

        const response = await fetch(
            'kdealer/ProcessBulkImportBatch/',
            {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                signal: bulkAbortControllerRef.current?.signal,
                body: JSON.stringify(requestBody)
            }
        );

        if (!response.ok) {
            let message = 'Bulk import batch failed.';

            try {
                const errorResponse = await response.json();
                message = errorResponse?.message || message;
            } catch {
            }

            throw new Error(message);
        }

        return await response.json();
    }

    const scrollToNextBatchMessageOnce = () => {
        if (firstBatchAutoScrolledRef.current) {
            return;
        }

        firstBatchAutoScrolledRef.current = true;

        const scrollWhenReady = (attemptNumber) => {
            requestAnimationFrame(() => {
                if (bulkLoadingMessageRef.current) {
                    bulkLoadingMessageRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'end'
                    });
                    return;
                }

                if (attemptNumber < 5) {
                    scrollWhenReady(attemptNumber + 1);
                }
            });
        };

        scrollWhenReady(1);
    }

    const LoadBulkSkus = async (bulkImport) => {
        const bulkImportKey = Number(bulkImport?.bulkImportKey);
        const totalItems = Number(bulkImport?.totalItems) || 0;

        if (!Number.isInteger(bulkImportKey) || bulkImportKey <= 0) {
            setErrorMessage('Unable to process the imported file.');
            return;
        }

        const currentRun = bulkRunRef.current + 1;
        bulkRunRef.current = currentRun;
        bulkAbortControllerRef.current?.abort();
        bulkAbortControllerRef.current = new AbortController();

        resetItems();
        setBulkData(null);
        setSelectedSKUs(new Set());
        setItemsSubtotal(0);
        setSubstitutionSkus([]);
        setAlertLTL(false);
        setAlertPk(false);
        setAlertFactorCount(0);
        setAlertRecallItem(0);
        setAlertBOCount(0);
        setSelectAll(false);
        setSelectMode(true);
        setLocalFromImport(true);
        setErrorMessage('');
        setBulkProcessingCount(0);
        setBulkBatchStatuses(buildBulkBatchStatuses(totalItems));
        setBulkImportStage('processing');
        setBulkResultsStarted(false);
        firstBatchAutoScrolledRef.current = false;
        setPop(true);

        CheckSession();
        const user = GetCoockie();

        if (!user || !user.dealerID) {
            bulkAbortControllerRef.current = null;
            setPop(false);
            setErrorMessage('Unable to determine the current dealer.');
            setBulkBatchStatuses(previousStatuses =>
                previousStatuses.map(batch => ({
                    ...batch,
                    status: 'failed'
                }))
            );
            setBulkImportStage('finished');
            return;
        }

        const maxConsecutiveApiFailures = 3;
        let totalBatches = Math.max(
            1,
            Math.ceil(totalItems / 50)
        );
        let remainingPendingCount = totalItems;
        let consecutiveApiFailures = 0;
        let stoppedAfterFailures = false;
        let unexpectedFailure = false;
        const retryDisplayBuffer = new Map();
        let retryDisplayGroupSize = Math.min(
            50,
            Math.max(totalItems, 1)
        );

        const isCurrentRun = () =>
            bulkRunRef.current === currentRun;

        const updateRemainingPendingCount = (result) => {
            const count = Number(result?.remainingPendingCount);

            if (Number.isInteger(count) && count >= 0) {
                remainingPendingCount = count;
            }
        };

        const recordApiResult = (succeeded) => {
            if (succeeded) {
                consecutiveApiFailures = 0;
                return;
            }

            consecutiveApiFailures += 1;

            if (consecutiveApiFailures >=
                maxConsecutiveApiFailures) {
                stoppedAfterFailures = true;
            }
        };

        const flushRetryDisplayBuffer = (force = false) => {
            while (retryDisplayBuffer.size > 0 &&
                (force ||
                    retryDisplayBuffer.size >=
                    retryDisplayGroupSize)) {

                const chunkSize = force
                    ? Math.min(
                        retryDisplayGroupSize,
                        retryDisplayBuffer.size
                    )
                    : retryDisplayGroupSize;

                const items = Array.from(
                    retryDisplayBuffer.values()
                ).slice(0, chunkSize);

                items.forEach(item => {
                    retryDisplayBuffer.delete(
                        item.bulkImportItemKey
                    );
                });

                appendBulkItems(items);

                retryDisplayGroupSize = Math.min(
                    50,
                    Math.max(
                        remainingPendingCount,
                        retryDisplayBuffer.size,
                        1
                    )
                );

                if (!force &&
                    retryDisplayBuffer.size <
                    retryDisplayGroupSize) {
                    break;
                }
            }
        };

        const bufferRetryItems = (items) => {
            if (!Array.isArray(items)) {
                return;
            }

            items.forEach(item => {
                if (item?.bulkImportItemKey != null) {
                    retryDisplayBuffer.set(
                        item.bulkImportItemKey,
                        item
                    );
                }
            });

            flushRetryDisplayBuffer(false);
        };

        const runRotatingPendingPass = async (
            pendingBatchSize
        ) => {
            let afterItemKey = 0;

            while (isCurrentRun() &&
                !stoppedAfterFailures &&
                remainingPendingCount > 0) {

                setBulkProcessingCount(
                    retryDisplayGroupSize
                );

                let result;

                try {
                    result = await requestBulkImportBatch(
                        bulkImportKey,
                        0,
                        false,
                        false,
                        0,
                        user,
                        {
                            processPending: true,
                            pendingBatchSize,
                            afterItemKey
                        }
                    );
                } catch (error) {
                    console.error(
                        `Bulk import pending pass (${pendingBatchSize}) failed:`,
                        error
                    );

                    recordApiResult(false);

                    continue;
                }

                if (!isCurrentRun()) {
                    return;
                }

                updateRemainingPendingCount(result);

                if (result?.skipped ||
                    Number(result?.requestedItemCount) === 0) {
                    break;
                }

                const nextItemKey = Number(result?.lastItemKey);
                const hasValidCursor =
                    Number.isInteger(nextItemKey) &&
                    nextItemKey > afterItemKey;
                const succeeded =
                    result?.succeeded === true &&
                    hasValidCursor;

                if (succeeded) {
                    bufferRetryItems(result.items);
                }

                recordApiResult(succeeded);

                if (!hasValidCursor) {
                    console.error(
                        'Bulk import pending response did not return ' +
                        'a valid item cursor.'
                    );

                    continue;
                }
                afterItemKey = nextItemKey;

                if (stoppedAfterFailures ||
                    result?.hasMore !== true) {
                    break;
                }
            }
        };

        try {

            for (let batchNumber = 1;
                batchNumber <= totalBatches;
                batchNumber += 1) {

                if (!isCurrentRun()) {
                    return;
                }

                if (stoppedAfterFailures) {
                    break;
                }

                const itemsBeforeThisBatch =
                    (batchNumber - 1) * 50;

                const recordsInThisBatch = totalItems > 0
                    ? Math.min(
                        50,
                        Math.max(
                            totalItems - itemsBeforeThisBatch,
                            0
                        )
                    )
                    : 50;

                setBulkProcessingCount(recordsInThisBatch);
                setBulkBatchStatuses(previousStatuses =>
                    previousStatuses.map(batch =>
                        batch.batchNumber === batchNumber
                            ? {
                                ...batch,
                                status: 'processing'
                            }
                            : batch
                    )
                );

                try {
                    const result =
                        await requestBulkImportBatch(
                            bulkImportKey,
                            batchNumber,
                            false,
                            false,
                            0,
                            user
                        );

                    if (!isCurrentRun()) {
                        return;
                    }

                    if (totalItems <= 0 &&
                        Number(result?.totalBatches) > 0) {
                        totalBatches =
                            Number(result.totalBatches);
                    }

                    updateRemainingPendingCount(result);

                    if (result?.succeeded === true) {
                        appendBulkItems(result.items);
                        setBulkBatchStatuses(previousStatuses =>
                            previousStatuses.map(batch =>
                                batch.batchNumber === batchNumber
                                    ? {
                                        ...batch,
                                        status: 'completed'
                                    }
                                    : batch
                            )
                        );

                        if (batchNumber === 1 && totalBatches > 1) {
                            scrollToNextBatchMessageOnce();
                        }
                    }

                    recordApiResult(
                        result?.succeeded === true
                    );
                } catch (error) {
                    console.error(
                        `Bulk import batch ${batchNumber} failed:`,
                        error
                    );
                    recordApiResult(false);
                }
            }

            retryDisplayGroupSize = Math.min(
                50,
                Math.max(remainingPendingCount, 1)
            );

            if (isCurrentRun() &&
                !stoppedAfterFailures &&
                remainingPendingCount > 0) {
                await runRotatingPendingPass(50);
            }

            while (isCurrentRun() &&
                !stoppedAfterFailures &&
                remainingPendingCount > 0) {

                const pendingBatchSize = Math.min(
                    50,
                    Math.max(
                        1,
                        Math.ceil(
                            remainingPendingCount / 2
                        )
                    )
                );

                await runRotatingPendingPass(
                    pendingBatchSize
                );

                if (!isCurrentRun() ||
                    stoppedAfterFailures ||
                    remainingPendingCount === 0) {
                    break;
                }

                const completePendingBatchSize = Math.min(
                    50,
                    remainingPendingCount
                );

                await runRotatingPendingPass(
                    completePendingBatchSize
                );
            }

            if (!isCurrentRun()) {
                return;
            }

            flushRetryDisplayBuffer(true);

            if (stoppedAfterFailures) {
                try {
                    await requestBulkImportBatch(
                        bulkImportKey,
                        0,
                        false,
                        false,
                        0,
                        user,
                        {
                            finalizePending: true
                        }
                    );
                } catch (finalizeError) {
                    console.error(
                        'Unable to finalize the stopped bulk import:',
                        finalizeError
                    );
                }

                setErrorMessage(
                    'Bulk import stopped after API failures. Please try later.'
                );
            }
        } catch (error) {
            if (isCurrentRun()) {
                unexpectedFailure = true;
                console.error(
                    'Bulk import processing failed:',
                    error
                );
                setErrorMessage(
                    error?.message ||
                    'Issue processing file, please try again.'
                );
            }
        } finally {
            if (isCurrentRun()) {
                const hasFailedRecords =
                    stoppedAfterFailures ||
                    unexpectedFailure ||
                    remainingPendingCount > 0;

                setBulkBatchStatuses(previousStatuses =>
                    previousStatuses.map(batch =>
                        batch.status === 'processing'
                            ? {
                                ...batch,
                                status: hasFailedRecords
                                    ? 'failed'
                                    : 'completed'
                            }
                            : batch
                    )
                );
                bulkAbortControllerRef.current = null;
                setBulkProcessingCount(0);
                setPop(false);
                setBulkImportStage('finished');
            }
        }
    }

    const handleCheckAvailability = () => {
        if (!bulkImportPreview || bulkImportStage !== 'preview') {
            return;
        }

        LoadBulkSkus(bulkImportPreview);
    }

    const ValidateSKUData = async () => {
        try {
            /*debugger;*/
            handlePop();
            CheckSession();
            $(':input').removeClass('is-invalid');

            let validatedArr = [];
            for (let i = 0; i < rows.length; i++) {
                let qtyint = parseInt(rows[i].qty);
                if (isNaN(qtyint) || qtyint <= 0) {
                    qtyint = 1;
                }
                const memo = (rows[i].memo || "").trim();
                const sku = (rows[i].sku || "").trim();

                if (sku !== "") {
                    validatedArr.push({
                        sku: sku,
                        qty: qtyint,
                        vin: memo
                    });
                } else if (rows[i].sku || rows[i].qty) {
                    const itmId = '#CtrlItemNum' + i;
                    const qtyId = '#CtrlQty' + i;
                    if (rows[i].sku) {
                        $(itmId).removeClass('is-invalid');
                    } else {
                        $(itmId).addClass('is-invalid');
                    }
                    if (rows[i].qty) {
                        $(qtyId).removeClass('is-invalid');
                    } else {
                        $(qtyId).addClass('is-invalid');
                    }
                }
            }
            handleClosePop();
            return validatedArr;
        } catch (e) {
            handleClosePop();
            console.log(e);
            return null;
        }
    }

    const GetSKUDetail = async (validatedArr) => {
        try {
            if (validatedArr.length === 0) {
                return;
            }
            setErrorMessage('');
            CheckSession();
            setSKUItems(new Map());
            setSelectedSKUs(new Set());
            handlePop();
            const user = GetCoockie();

            //Item availability
            const skuqty = {
                valueLabels: validatedArr,
                orderType: orderType ? orderType.toString() : '1',
                dealerID: user.dealerID,
                userKey: user.userKey
            };
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(skuqty)
            };
            const res = await fetch('kdealer/GetSkuInfo/', rqst);

            if (res.status !== 200) {
                const error = new Error(res.statusText);
                error.status = res.status;
                throw error;
            }
            const js = await res.json();
            console.log(SKUItems.values());

            const addInfo = new Map();
            const newSkuQty = [];
            const arrSubs = [];
            let errorSet = new Set();
            const invalidSet = new Set();
            setAlertLTL(false);
            let alertFactor = 0, boCount = 0, recallItem = 0;
            console.log(js);

            const validSet = new Set(
                js.map(item => item.distitemNbr?.toUpperCase().replaceAll('-', '')).filter(Boolean)
            );

            rows.forEach(row => {
                if (row.sku) {
                    const normalizedInput = row.sku?.toUpperCase().replaceAll('-', '');
                    if (row.sku !== "" && !validSet.has(normalizedInput)) {
                        invalidSet.add(normalizedInput);
                    }
                }
            });

            js.map((item) => {
                const normalizedItem = item.distitemNbr?.toUpperCase().replaceAll('-', '');
                setIsDealer(item.isDealer);

                if (item.recallItemCode === "QR" || item.recallItemCode === "QV") {
                    /*item.errorMsg = `${item.distitemNbr}: To order this recall part, this transaction must be started from the Vehicle Information Portal`;*/
                    if (normalizedItem) {
                        invalidSet.add(normalizedItem);
                        item.qty = 0;
                        item.itemStaCode = "4";
                    }
                }

                if (item.errorMsg?.toLowerCase().includes("invalid") || item.itemStaCode === "4") {
                    if (normalizedItem) {
                        invalidSet.add(normalizedItem);
                        item.qty = 0;
                        console.log(invalidSet)
                    }
                }

                if (item.distitemNbr !== "") {
                    if (item.itemStaCode === "1" || item.itemStaCode === "2" || item.itemStaCode === "4") {
                        newSkuQty.push({
                            sku: item.distitemNbr,
                            qty: item.qty,
                            vin: item.vin
                        });

                        if (item.substitutedSKU !== "") {
                            arrSubs.push(`${item.substitutedSKU} is substituted by ${item.distitemNbr}`);
                            console.log('error 1')
                        }
                        if (item.ltl === true) {
                            setAlertLTL(true);
                            console.log('error 2')
                        }
                        if (item.pk === true) {
                            setAlertPk(true);
                            console.log('error 3')
                        }
                        if (item.itemStaCode === "4") {
                            item.qty = 0;
                            console.log('error 4')
                        }
                        if (item.factorAlert === true) {
                            alertFactor++;
                            console.log('error 5')
                        }
                        if (item.boCnt > 0) {
                            boCount++;
                            console.log('error 6')
                        }
                        if (item.recallItemCode === "QR" || item.recallItemCode === "QV") {
                            recallItem++;
                            console.log('error 7')
                        }
                    }
                }

                if (item.errorMsg !== "") {
                    //errorSet.add(item.distitemNbr + ": " + item.errorMsg);
                    if (item.errorMsg.toLowerCase().indexOf("invalid part number") > -1) {
                        errorSet.add("Please correct the invalid item numbers below.");
                        setAddSKUError(Array.from(errorSet));
                    }
                    //else {
                    //    errorSet.add(item.distitemNbr + ": "+ item.errorMsg);
                    //}
                }
                return '';
            });
            //const sortedArray = js.sort((a, b) => {
            //    // Define the condition check
            //    const isPriority = (item) =>
            //        item.substitutedSKU !== '' &&
            //        item.ltl === true &&
            //        item.pk === true &&
            //        item.factorAlert === true &&
            //        item.boCnt > 0;

            //    const aMatch = isPriority(a);
            //    const bMatch = isPriority(b);

            //    // Sort priority items (true) before non-priority (false)
            //    // In JavaScript, true - false = 1, so we do b - a to put true first
            //    return bMatch - aMatch;
            //});
            //js = sortedArray;
            setInvalidSkus(invalidSet);
            setAlertBOCount(boCount);
            setSubstitutionSkus(arrSubs);
            setAlertFactorCount(alertFactor);
            setAlertRecallItem(recallItem);
            //Item Number
            const skuqty2 = {
                valueLabels: newSkuQty,
                orderType: orderType ? orderType.toString() : '1',
                dealerID: user.dealerID
            };
            const rqst2 = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(skuqty2)
            };
            const res2 = await fetch('kdealer/GetSkuInfo2/', rqst2);

            if (res2.status === 400 && !fromImport) {
                handleClosePop();
                setErrorMessage('Please correct the invalid item numbers.');

                return;
            } else if (res2.status !== 200) {
                handleClosePop();
                if (fromImport) {
                    setErrorMessage('Issue processing file, please try again.');
                } else if (errorSet.size !== 0) {
                    setErrorMessage('There was an issue processing the information, please try again.');
                }

                const error = new Error(res.statusText);
                error.status = res.status;
                throw error;
            }

            const js2 = await res2.json();

            js2.map((item) => {
                if (item.itemStaCode === "1" || item.itemStaCode === "2" || item.itemStaCode === "4") {
                    addInfo.set(item.itemNumber.replaceAll('-', ''), item);
                }
                return '';
            });

            //let arr = [];
            let acctotal = 0;
            //let errorSet = new Set();

            js.map((item) => {
                if (item.distitemNbr !== "") {
                    const newDistrNum = item.distitemNbr.replaceAll('-', '');
                    const info = {
                        item: item,
                        addInfo: addInfo.get(newDistrNum)
                    }
                    const cleanid = newDistrNum + (item.vin && item.vin !== '' ? ('|' + item.vin) : '');
                    if (item.itemStaCode === "1" || item.itemStaCode === "2") {

                        //setSelectedSKUs(prev => new Set(prev).add(newDistrNum+"|"+item.vin));
                        setSelectedSKUs(prev => new Set(prev).add(cleanid));
                        const quantity = (Number(item.qty) || 0) + (Number(item.boCnt) || 0);
                        acctotal += quantity * (Number(item.dealerPrice) || 0);
                    }
                    setSKUItems(prevSKUItems => new Map(prevSKUItems).set(cleanid, info));
                }
                return '';
            });

            setItemsSubtotal(acctotal);

            if (results && modalBody) {
                const top = results.getBoundingClientRect().top - modalBody.getBoundingClientRect().top + modalBody.scrollTop;

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        modalBody.scrollTo({
                            top,
                            behavior: 'smooth'
                        });
                    });
                });
            }

            handleClosePop();
        } catch (e) {
            handleClosePop();
            if (fromImport) {
                setErrorMessage('Issue processing file, please try again.')
            } else if (e.status === 400) {
                setErrorMessage('Please correct the invalid item numbers.')
            } else {
                setErrorMessage('There was an issue processing the information, please try again.')
            }
            console.log(e);
            return;
        }
    }

    const validItems = [...SKUItems.values()].filter(
        d => d.item.itemStaCode === "1" || d.item.itemStaCode === "2" || d.item.itemStaCode === "4"
    )

    const decodeHtml = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    const AddSkuClick = async () => {
        const data = await ValidateSKUData();
        GetSKUDetail(data);
        handleSelectAll();
    }

    const getSKUItemKey = (skuItem) => {
        if (skuItem.rowKey) {
            return skuItem.rowKey;
        }

        const item = skuItem.item;

        return item.distitemNbr.replaceAll('-', '') +
            (item.vin && item.vin !== '' ?
                ('|' + item.vin) : '');
    }

    const selectAllItems = () => {
        const skuArray = Array.from(SKUItems.values());
        const set = new Set();
        if (selectMode) {
            for (let i = 0; i < skuArray.length; i++) {
                set.add(getSKUItemKey(skuArray[i]));
                //set.add(skuArray[i].item.distitemNbr.replaceAll('-', ''));
            }
        }
        setSelectedSKUs(set);
        setSelectMode(prev => !prev);
    }

    const handleSelectAll = () => {
        const skuArray = Array.from(SKUItems.values());
        const set = new Set();
        for (let i = 0; i < skuArray.length; i++) {
            const cleanid = getSKUItemKey(skuArray[i]);
            //var $checkbox = $('#check' + itmNum);
            var $checkbox = $(`[id="check${cleanid}"]`);
            if ($checkbox.length > 0) {
                //set.add(itmNum);
                set.add(cleanid);
            }

        }
        setSelectedSKUs(set);

        if (selectAll) {
            setSelectAll(false);
            setSelectedSKUs(new Set());
        } else {
            setSelectAll(true);
        }
    }

    useEffect(() => {
        if (SelectedSKUs.size === SKUItems.size) {
            setSelectAll(true);
        }
    }, [SelectedSKUs, SKUItems])

    useEffect(() => {
        const skuArray = Array.from(SKUItems.values());
        if (SelectedSKUs.size < skuArray.length) {
            setSelectMode(true);
        }
    }, [SelectedSKUs, SKUItems])

    const getStatusIcon = (code) => {
        const color = code.charAt(0);
        const number = code.slice(1);

        switch (color) {
            case "G":
                return (
                    <div className="icons-row">
                        <div className="status-icon green-icon"></div>
                        {/*<span>{parseFloat(number)}</span>*/}
                    </div>
                );
            case "Y":
                return (
                    <div className="icons-row">
                        <div className="status-icon yellow-icon"></div>
                        {/*<span>{parseFloat(number)}</span>*/}
                    </div>
                );
            default:
                return (
                    <div className="icons-row">
                        <div className="status-icon red-icon"></div>
                        {/*<span>{parseFloat(number)}</span>*/}
                    </div>
                );
        }
    };

    const isBulkPreview =
        localFromImport && bulkImportStage === 'preview';

    const isBulkProcessing =
        localFromImport && bulkImportStage === 'processing';

    const showBulkPreviewResults =
        localFromImport &&
        (bulkImportStage === 'preview' ||
            (bulkImportStage === 'processing' && !bulkResultsStarted));

    const bulkTotalRecords =
        Number(bulkImportPreview?.totalItems) || 0;

    const renderBulkInstructions = () => {
        if (isBulkPreview) {
            return (
                <Table bordered className="mt-4 text-left">
                    <thead>
                        <tr>
                            <th style={{ backgroundColor: '#000', color: '#fff' }}>Records</th>
                            <th style={{ backgroundColor: '#000', color: '#fff' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{bulkTotalRecords}</td>
                            <td className="bold">Total Records</td>
                        </tr>
                    </tbody>
                </Table>
            );
        }

        return (
            <>
                <Table bordered className="mt-4 text-left">
                    <thead>
                        <tr>
                            <th style={{ backgroundColor: '#000', color: '#fff' }}>Records</th>
                            <th style={{ backgroundColor: '#000', color: '#fff' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {bulkBatchStatuses.map(batch => (
                            <tr key={`bulk-batch-${batch.batchNumber}`}>
                                <td>{batch.start}-{batch.end}</td>
                                <td>
                                    <span
                                        className="bold"
                                        style={{
                                            color: batch.status === 'completed'
                                                ? '#198754'
                                                : batch.status === 'pending'
                                                    ? '#000000'
                                                    : '#ff0000'
                                        }}
                                    >
                                        {batch.status === 'completed'
                                            ? 'Completed'
                                            : batch.status === 'failed'
                                                ? 'Failed'
                                                : batch.status === 'pending'
                                                    ? 'Pending'
                                                    : 'Processing'}
                                        {batch.status === 'processing' &&
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    marginLeft: '6px',
                                                    verticalAlign: 'middle'
                                                }}
                                            >
                                                <PulseLoader
                                                    color="#ff0000"
                                                    size="4px"
                                                    margin="2px"
                                                />
                                            </span>
                                        }
                                    </span>
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td className="bold">{bulkTotalRecords}</td>
                            <td className="bold">Total Records</td>
                        </tr>
                    </tbody>
                </Table>

                {isBulkProcessing ?
                    <p className="red text-left mt-4" style={{ fontStyle: 'italic' }}>
                        Please allow processing to complete.<br />
                        Add to Order will become available once all records have processed.
                    </p>
                    :
                    <p
                        className="text-left mt-4"
                        style={{
                            color: '#198754',
                            fontStyle: 'italic',
                            fontWeight: '700'
                        }}
                    >
                        Processing is complete.<br />
                        Click Add to Order to continue.
                    </p>
                }
            </>
        );
    };

    const renderBulkPreview = () => (
        <Table bordered responsive className="mt-4">
            <thead>
                <tr>
                    <th style={{ backgroundColor: '#000', color: '#fff' }}>Line #</th>
                    <th style={{ backgroundColor: '#000', color: '#fff' }}>Item Number</th>
                    <th style={{ backgroundColor: '#000', color: '#fff' }}>Quantity</th>
                    <th style={{ backgroundColor: '#000', color: '#fff' }}>Memo</th>
                </tr>
            </thead>
            <tbody>
                {(bulkImportPreview?.items || []).map(item => (
                    <tr key={`bulk-preview-${item.lineNumber}`}>
                        <td>{item.lineNumber}</td>
                        <td>{item.sku}</td>
                        <td>{item.qty}</td>
                        <td>{item.memo || '-'}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );

    return (
        <>
            <Modal show={show} onHide={() => undefined} scrollable size="xl" dialogClassName="modal-90w dealer-section item-inquiry-modal" style={showModelModal && { zIndex: 100 }} backdrop={true} keyboard={false}>
                <Modal.Header>
                    <Row className="w-100w">
                        <Col xxl={localFromImport ? 3 : 6} className="text-left">
                            <Modal.Title>{localFromImport ? t('importInstructions.importInstructions') : t('iteminquiry.ITEM INQUIRY ADD')}</Modal.Title>
                        </Col>

                        {(localFromImport || SKUItems.size > 0) &&
                            <>
                                <Col
                                    sm={localFromImport ? undefined : { span: 5, offset: 1 }}
                                    xxl={localFromImport ? 9 : undefined}
                                    className="xl-hidden text-left text-start"
                                >
                                    <Modal.Title className="text-left text-start" style={{ textAlign: 'left' }}>
                                        {localFromImport ? t('iteminquiry.importResults') : t('iteminquiry.ITEM INQUIRY RESULTS')}
                                    </Modal.Title>
                                </Col>
                            </>
                        }
                    </Row>
                    <CloseButton variant="white" data-bs-theme="dark" className="btn-close-sibling" onClick={handleItemInquiryClose} />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} md={12} xl={12} xxl={3} className="item-inquiry-search">
                            <div className="sticky">

                                {localFromImport ?
                                    renderBulkInstructions()
                                    :
                                    <>
                                        {AddSKUError.length > 0 &&
                                            <>
                                                {AddSKUError.map((d, idx) =>
                                                    <p className="red mt-2" key={"error" + idx}>{decodeHtml(d)}</p>)
                                                }
                                            </>
                                        }

                                        <p className="bold text-left mt-2">{t('iteminquiry.Search Up to 10 Items')}</p>

                                        {pop &&
                                            <p className="bold">Loading...</p>
                                        }

                                        <Row>
                                            <Col xs={6} sm={6} lg={6} xl={6}>
                                                <p className="red mb-0 text-left">{t('iteminquiry.Required')}</p>
                                            </Col>
                                            <Col xs={3} sm={3} col lg={3} xl={3}>
                                                <p className="mb-0 text-left small-text">{t('iteminquiry.Optional')}</p>
                                            </Col>
                                            <Col xs={3} sm={3} col lg={3} xl={3}>
                                                <p className="text-left mb-0 padding-right-extra small-text">{t('iteminquiry.Optional')}</p>
                                            </Col>
                                        </Row>

                                        {rows.map((row, index) => {
                                            const normalizedInput = row.sku?.toUpperCase().replaceAll('-', '');
                                            const isInvalid = invalidSkus.has(normalizedInput);

                                            return (
                                                <div key={index} className="form-group">
                                                    <Row className="item-inquiry-search-row mb-1 g-1">
                                                        {/*<Col xs={1} sm={1} lg={1} xl={1} className="mt-3 no-padding-right">{index + 1}</Col>*/}
                                                        <Col xs={6} sm={6} lg={6} xl={6}>
                                                            <FloatingLabel controlId={"CtrlItemNum" + index} label={t("textfield.Item Number")}>
                                                                <Form.Control
                                                                    placeholder={t("textfield.Item Number")}
                                                                    value={row.sku}
                                                                    onChange={(event) => handleInputChange(index, event)}
                                                                    className={isInvalid ? "red-alert-input form-control" : "form-control"}
                                                                    name="sku"
                                                                    ref={(el) => (inputRefs.current[index] = el)}
                                                                />
                                                            </FloatingLabel>
                                                        </Col>
                                                        <Col xs={3} sm={3} col lg={3} xl={3}>
                                                            <FloatingLabel controlId={"CtrlQty" + index} label={t("textfield.Qty")}>
                                                                <Form.Control placeholder="Qty" value={row.qty} onChange={(event) => handleInputChange(index, event)} className="form-control" name="qty" />
                                                            </FloatingLabel>
                                                        </Col>
                                                        <Col xs={3} sm={3} col lg={3} xl={3}>
                                                            <FloatingLabel controlId={"CtrlMemo" + index} label={'Memo'}>
                                                                <Form.Control placeholder="Memo" value={row.memo} onChange={(event) => handleInputChange(index, event)} className="form-control" name="memo" maxLength={7} />
                                                            </FloatingLabel>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                        })}
                                    </>
                                }

                            </div>
                        </Col>

                        <Col sm={12} md={12} xl={12} xxl={9} className="mt-2" id="itemInquiryResults">
                            {(localFromImport || SKUItems.size > 0) &&
                                <h3 className="heading bold xxl-hidden xl-show mt-4 mb-3">{localFromImport ? t('iteminquiry.importResults') : t('iteminquiry.ITEM INQUIRY RESULTS')}</h3>
                            }

                            {showBulkPreviewResults ?
                                renderBulkPreview()
                                : validItems.length > 0 ?
                                    <>
                                        <div className="sticky fixed-legend">
                                            <Row className="table-legend g-0">
                                                <Col sm={2} className="text-left padding-left-extra">
                                                    {/*<Button variant={selectMode ? "outline-dark" : "dark"} onClick={selectAllItems}>{selectMode ? "Select All" : "Unselect All"}</Button>*/}
                                                    <Form.Check
                                                        type="checkbox"
                                                        name="selectAll"
                                                        aria-label='Select All'
                                                        label={t("form.Select All")}
                                                        checked={selectAll}
                                                        onChange={handleSelectAll}
                                                    />
                                                </Col>
                                                <Col sm={10}>
                                                    <div className="table-legend-section">
                                                        <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> {t("table.Parts")}</span>
                                                        <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> {t("table.Accessories")}</span>
                                                        <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> {t("table.Other")}</span>
                                                    </div>

                                                    <div className="table-legend-section">
                                                        <span className="icons-row"><div className={`status-icon green-icon`}></div> {t("table.Available")}</span>
                                                        <span className="icons-row"><div className={`status-icon yellow-icon`}></div> {t("table.Partial")}</span>
                                                        <span className="icons-row"><div className={`status-icon red-icon`}></div> {t("table.Unavailable")}</span>
                                                    </div>

                                                    <div className="table-legend-section">
                                                        <span className="svg-holder"><img className="asterisk-img" src={"../../../Images/asterisk.svg"} alt="asterisk" /> {t("table.Pkg Qty")}</span>
                                                        <span className="svg-holder"><img src="../../../Images/substitute.svg" alt="" className="" /> {t("table.Substitute")}</span>
                                                        <span className="svg-holder"><img className="" src={"../../../Images/LTL.svg"} alt="LTL" /> {t("table.LTL")}</span>
                                                        <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> {t("table.Backorder")}</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>

                                        <div className="item-inquiry-list">
                                            <div className="alerts-section" style={AlertFactorCount < 1 && !AlertLTL && SubstitutionSkus.length < 1 && (ItemsSubtotal < 1000 || isDealer === false) && AlertBOCount < 1 && !alertPk && alertRecallItem === 0 ? { border: "none" } : {}} >
                                                <Row>
                                                    {AlertFactorCount > 0 &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti asterisk-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img className="asterisk-img" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                                </span>
                                                                <p className="mb-0">
                                                                    {AlertFactorCount === 1 ?
                                                                        t("table.factorOrder_one", { count: AlertFactorCount })
                                                                        :
                                                                        t("table.factorOrder_other", { count: AlertFactorCount })
                                                                    }
                                                                </p>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {AlertLTL === true &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti ltl-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img className="" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                                </span>

                                                                <p className="mb-0">{t("table.ltlOrder")}</p>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {SubstitutionSkus.length > 0 &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti substitute-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img className="red-filter" src={"../../../Images/substitute.svg"} alt="Substitute"></img>
                                                                </span>

                                                                <p className="mb-0">{t("table.substitutionOrder")}</p>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {AlertBOCount > 0 &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img src="../../../Images/backorder.svg" alt="Alert" />
                                                                </span>

                                                                <p className="mb-0">{t("table.backorderOrder")}</p>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {alertPk &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img src="../../../Images/backorder.svg" alt="Alert" />
                                                                </span>

                                                                <p className="mb-0">{t("table.packagesBuiltOrder")}</p>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {ItemsSubtotal > 1000 && isDealer === true &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                <p className="red mb-0 text-left padding-left-extra">{t("table.airShippingRestriction")}</p>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {alertRecallItem > 0 &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                <p className="red mb-0 text-left padding-left-extra">There is a recall item in your order, this transaction must be started from the Vehicle Information Portal to complete.</p>
                                                            </div>
                                                        </Col>
                                                    }
                                                </Row>
                                            </div>

                                            {validItems.map((d, idx) => (
                                                <div key={d.rowKey || ("sku" + idx.toString())} className="item-inquiry-item">
                                                    <Row>
                                                        {d.item.factorAlert &&
                                                            <Col sm={12}>
                                                                <div className="icons-row alert-noti asterisk-noti text-left">
                                                                    <span className="svg-holder small-svg">
                                                                        <img className="asterisk-img white-filter" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                                    </span>

                                                                    <p className="mb-0">{t("table.factorItem")}</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.ltl &&
                                                            <Col sm={12}>
                                                                <div className="icons-row alert-noti ltl-noti text-left">
                                                                    <span className="svg-holder small-svg">
                                                                        <img className="white-filter" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                                    </span>

                                                                    <p className="mb-0">{t("table.ltlItem")}</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.substitutedSKU !== '' &&
                                                            <Col sm={12}>
                                                                <div className="icons-row substitute-noti alert-noti text-left">
                                                                    <span className="svg-holder small-svg">
                                                                        <img className="white-filter" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img>
                                                                    </span>

                                                                    <p className="mb-0">{t("table.substitutionItem", { subSku: d.item.substitutedSKU, newSku: d.item.distitemNbr })}</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.pk &&
                                                            <Col sm={12}>
                                                                <div className="icons-row substitute-noti alert-noti text-left">
                                                                    <span className="svg-holder small-svg">
                                                                        <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                    </span>

                                                                    <p className="mb-0">{t("table.packagesBuiltItem")}</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.boCnt > 0 &&
                                                            <Col sm={12}>
                                                                <div className="icons-row alert-noti bo-noti text-left">
                                                                    <span className="svg-holder small-svg">
                                                                        <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                    </span>

                                                                    <p className="mb-0">{t("table.backorderItem")}</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.recallItemCode &&
                                                            <Col sm={12}>
                                                                <div className="icons-row alert-noti text-left">
                                                                    {/*<span className="svg-holder small-svg">*/}
                                                                    {/*    <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />*/}
                                                                    {/*</span>*/}

                                                                    <p className="mb-0">
                                                                        To order this recall part, this transaction must be started from the Vehicle Information Portal
                                                                    </p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.notAvailable === true &&
                                                            <Col sm={12}>
                                                                <div className="icons-row alert-noti bo-noti text-left">
                                                                    <p className="mb-0">Item is not available</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.ePA49Form === true &&
                                                            <Col sm={12}>
                                                                <div className="icons-row alert-noti bo-noti text-left">
                                                                    <p className="mb-0">EPA-49 form required. Froms available under P&A/item information/ATV/SXS component assemblies</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.ePARegulated === true &&
                                                            <Col sm={12}>
                                                                <div className="icons-row alert-noti bo-noti text-left">
                                                                    <p className="mb-0">EPA Regulated. Email EPAparts@kmc-usa.com with VIN, part number, and dealer number.</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.callDealerCare === true &&
                                                            <Col sm={12}>
                                                                <div className="icons-row alert-noti bo-noti text-left">
                                                                    <p className="mb-0">Call Dealer Care 800-854-3800</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                        {d.item.otherError === true && d.item.errorMsg && d.item.errorMsg !== '' &&
                                                            <Col sm={12}>
                                                                <div className="icons-row alert-noti bo-noti text-left">
                                                                    <p className="mb-0">{d.item.errorMsg}</p>
                                                                </div>
                                                            </Col>
                                                        }
                                                    </Row>

                                                    <Row>
                                                        <Col sm={12}>
                                                            <Row className="mt-3">
                                                                <Col sm={4} lg={2}>
                                                                    <Row>
                                                                        <Col xs={3} className="mt-5 padding-left-extra-md padding-right-extra-sm">
                                                                            {(d.item.itemStaCode === "1" || d.item.itemStaCode === "2") &&
                                                                                <Form.Check
                                                                                    type={'checkbox'}
                                                                                    id={'check' + getSKUItemKey(d)}
                                                                                    aria-label="Item 1"
                                                                                    name="invoiceNum-checkbox"
                                                                                    checked={SelectedSKUs.has(getSKUItemKey(d))}
                                                                                    onChange={handleSelectItem}
                                                                                />
                                                                            }
                                                                        </Col>

                                                                        <Col xs={9} className="item-inquiry-image">
                                                                            <img src={KImageURL(d.item.distitemNbr, d.addInfo.img)}
                                                                                onError={({ currentTarget }) => {
                                                                                    currentTarget.onerror = null;
                                                                                    currentTarget.src = DefaultImage;
                                                                                }}
                                                                                alt="Product"
                                                                                className={d.item.factorAlert || d.item.statusIcon.indexOf('.svg') > -1 || d.item.ltl || d.item.substitutedSKU !== '' || d.item.boCnt > 0 ? "item-image red-border" : "item-image"}>
                                                                            </img>
                                                                        </Col>
                                                                    </Row>
                                                                </Col>

                                                                <Col sm={4} lg={2} className="text-left">
                                                                    <p className={d.item.factorAlert || d.item.statusIcon.indexOf('.svg') > -1 || d.item.ltl || d.item.substitutedSKU !== '' || d.item.boCnt > 0 ? "mb-0 red" : "mb-0"}>{d.addInfo && d.addInfo.itemDesc}</p>
                                                                    <p className="mb-0">
                                                                        <Trans
                                                                            i18nKey="form.Item No"
                                                                            components={{ sup: <sup /> }}
                                                                        />
                                                                        : {d.item.distitemNbr}
                                                                    </p>

                                                                    {d.item.vin &&
                                                                        <p className="mb-0">Memo: {d.item.vin}</p>
                                                                    }

                                                                    <div className="icons-row">
                                                                        <span className="svg-holder small-svg">
                                                                            <img src={"../../../Images/" + d.item.inventoryTypeIcon} alt={d.item.inventoryTypeIcon} ></img>
                                                                        </span>

                                                                        {d.item.statusIcon.indexOf('.svg') > -1 ?
                                                                            <>|<span className="svg-holder small-svg"><img className="margin-left" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img></span></> :
                                                                            <>|<span className="svg-holder small-svg"><div className={`status-icon ${d.item.statusIcon}`}></div></span></>
                                                                        }

                                                                        {d.item.boCnt > 0 && <>|<span className="svg-holder small-svg"><img src="../../../Images/backorder.svg" alt="Alert" className="margin-left" /></span></>}

                                                                        {d.item.factorAlert &&
                                                                            <>|<span className="svg-holder small-svg"><img src="../../../Images/asterisk.svg" alt="asterisk" className="asterisk-img margin-left" /></span></>
                                                                        }

                                                                        {d.item.ltl &&
                                                                            <>|<span className="svg-holder small-svg"><img src="../../../Images/LTL.svg" alt="LTL" className="margin-left" /></span></>
                                                                        }
                                                                    </div>

                                                                    {d.addInfo &&
                                                                        <DropdownButton
                                                                            variant="outline-dark"
                                                                            title={t("form.View Details")}
                                                                            id="details-dropdown"
                                                                            className="mt-2 mb-2 dropdown-info"
                                                                        >
                                                                            <Dropdown.ItemText><span className="bold">{t('form.Vehicle Use')}:</span> {d.addInfo.prodLinesText}</Dropdown.ItemText>
                                                                            <Dropdown.Item><span className="bold">{t('form.Model Year(s)')}:</span> {d.addInfo.yearString} <span className="underline" onClick={() => handleModelModalShow(d.item.distitemNbr)}>{t('form.View Models')}</span></Dropdown.Item>
                                                                            {/*<Dropdown.Item><span className="bold">Eligible Exchange/Return:</span> {d.addInfo.eligibleExchangeReturn}</Dropdown.Item>*/}
                                                                            <Dropdown.Item><span className="bold">{t('form.Dimensions (LxWxHxG) (In)')}:</span> {d.addInfo.dimentions}</Dropdown.Item>
                                                                            <Dropdown.Item><span className="bold">{t('form.Weight (lb) / Volume (ci)')}:</span> {d.addInfo.weightVal}</Dropdown.Item>
                                                                            {d.addInfo && d.addInfo.installPDF && d.addInfo.installPDF !== '' &&
                                                                                <Dropdown.ItemText><a href={d.addInfo.installPDF} target="_blank" rel="noreferrer" className="black-text">Installation Instructions</a></Dropdown.ItemText>
                                                                            }
                                                                        </DropdownButton>
                                                                    }
                                                                </Col>

                                                                <Col sm={12} lg={8} className="pl-0 pl-0-md">
                                                                    <Table bordered>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>
                                                                                    {d.item.isDealer === true ?
                                                                                        <Trans
                                                                                            i18nKey="form.Dealer Price"
                                                                                            components={{ br: <br /> }}
                                                                                        /> :
                                                                                        t('form.Distributor / Dealer Price')
                                                                                    }
                                                                                </th>
                                                                                <th>{t('form.MSRP')}</th>
                                                                                <th className="black-bg">
                                                                                    <Trans
                                                                                        i18nKey="form.Order Qty"
                                                                                        components={{ br: <br /> }}
                                                                                    />
                                                                                </th>
                                                                                <th>
                                                                                    <Trans
                                                                                        i18nKey="form.Avail Qty"
                                                                                        components={{ br: <br /> }}
                                                                                    />
                                                                                </th>
                                                                                <th>CA <br /> (L)</th>
                                                                                <th>KY <br /> (R)</th>
                                                                                <th>TX <br /> (D)</th>
                                                                                <th>
                                                                                    <Trans
                                                                                        i18nKey="form.Pkg Qty"
                                                                                        components={{ br: <br /> }}
                                                                                    />
                                                                                </th>
                                                                                {d.item.boCnt > 0 && <th>BO</th>}
                                                                                <th>{t('form.Exc / Rtn')}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                {d.item.isDealer === true ?
                                                                                    <td>{FormatCurrency(d.item.dealerPrice)}</td> :
                                                                                    <td>{FormatCurrency(d.item.dealerPrice)} / {FormatCurrency(d.item.dealerPriceForDistributorDisplayOnly)}</td>
                                                                                }
                                                                                <td>{FormatCurrency(d.item.retailPrice)}</td>
                                                                                <td>{d.item.qtyOrdered}</td>
                                                                                <td>{d.item.qty}</td>
                                                                                <td>{getStatusIcon(d.item.warehouseAvailColorL)}</td>
                                                                                <td>{getStatusIcon(d.item.warehouseAvailColorR)}</td>
                                                                                <td>{getStatusIcon(d.item.warehouseAvailColorD)}</td>
                                                                                <td>{d.item.whslePkgCnt}</td>
                                                                                {d.item.boCnt > 0 && <td>{d.item.boCnt}</td>}
                                                                                <td>{d.addInfo.eligibleExchangeReturn}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </Table>
                                                                    {/*</Col>*/}

                                                                    {/*<Col sm={3} lg={1} className="pr-0 pl-0">*/}
                                                                    {/*<Table bordered>*/}
                                                                    {/*    <thead>*/}
                                                                    {/*        <tr>*/}
                                                                    {/*            <th className="black-bg">*/}
                                                                    {/*                <Trans*/}
                                                                    {/*                    i18nKey="form.Order Qty"*/}
                                                                    {/*                    components={{ br: <br /> }}*/}
                                                                    {/*                />*/}
                                                                    {/*            </th>*/}
                                                                    {/*        </tr>*/}
                                                                    {/*    </thead>*/}
                                                                    {/*    <tbody>*/}
                                                                    {/*        <tr>*/}
                                                                    {/*            <td>{d.item.qtyOrdered}</td>*/}
                                                                    {/*        </tr>*/}
                                                                    {/*    </tbody>*/}
                                                                    {/*</Table>*/}
                                                                    {/*</Col>*/}

                                                                    {/*<Col sm={9} lg={5} className="pl-0">*/}
                                                                    {/*<Table bordered>*/}
                                                                    {/*    <thead>*/}
                                                                    {/*        <tr>*/}
                                                                    {/*            <th>*/}
                                                                    {/*                <Trans*/}
                                                                    {/*                    i18nKey="form.Avail Qty"*/}
                                                                    {/*                    components={{ br: <br /> }}*/}
                                                                    {/*                />*/}
                                                                    {/*            </th>*/}
                                                                    {/*            <th>CA <br /> (L)</th>*/}
                                                                    {/*            <th>KY <br /> (R)</th>*/}
                                                                    {/*            <th>TX <br /> (D)</th>*/}
                                                                    {/*            <th>*/}
                                                                    {/*                <Trans*/}
                                                                    {/*                    i18nKey="form.Pkg Qty"*/}
                                                                    {/*                    components={{ br: <br /> }}*/}
                                                                    {/*                />*/}
                                                                    {/*            </th>*/}
                                                                    {/*            {d.item.boCnt > 0 && <th>BO</th>}*/}
                                                                    {/*            <th>{t('form.Exc / Rtn')}</th>*/}
                                                                    {/*        </tr>*/}
                                                                    {/*    </thead>*/}
                                                                    {/*    <tbody>*/}
                                                                    {/*        <tr>*/}
                                                                    {/*            <td>{d.item.qty}</td>*/}
                                                                    {/*            <td>{getStatusIcon(d.item.warehouseAvailColorL)}</td>*/}
                                                                    {/*            <td>{getStatusIcon(d.item.warehouseAvailColorR)}</td>*/}
                                                                    {/*            <td>{getStatusIcon(d.item.warehouseAvailColorD)}</td>*/}
                                                                    {/*            <td>{d.item.whslePkgCnt}</td>*/}
                                                                    {/*            {d.item.boCnt > 0 && <td>{d.item.boCnt}</td>}*/}
                                                                    {/*            <td>{d.addInfo.eligibleExchangeReturn}</td>*/}
                                                                    {/*        </tr>*/}
                                                                    {/*    </tbody>*/}
                                                                    {/*</Table>*/}
                                                                </Col>
                                                            </Row>
                                                        </Col>

                                                    </Row>
                                                </div>
                                            ))}

                                            {localFromImport && pop &&
                                                <div ref={bulkLoadingMessageRef} className="text-center mt-4 mb-4">
                                                    {bulkProcessingCount > 0 &&
                                                        <>
                                                            <p className="mb-1">
                                                                Processing the next {bulkProcessingCount} records.  Please don't close this window.
                                                            </p>
                                                        </>
                                                    }
                                                    <PulseLoader color="#66cc33" size="12px" margin="8px" />
                                                </div>
                                            }
                                        </div>
                                    </>

                                    : pop ?
                                        <div className="text-center mt-5">
                                            {localFromImport && bulkProcessingCount > 0 &&
                                                <>
                                                    <p className="mb-1">
                                                        Processing the records. Please don't close this window.
                                                    </p>
                                                </>
                                            }
                                            <PulseLoader color="#66cc33" size="20px" margin="12px" className="mt-5" />
                                        </div>
                                        :
                                        <div className="text-center align-content-center h-100">
                                            <p className="red bold">{errorMessage}</p>
                                        </div>
                            }
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="black-bg">
                    <Row className="w-100w gy-3">
                        {!localFromImport &&
                            <Col xxl={3}>
                                <Row>
                                    <Col className="text-left">
                                        <Button variant="secondary" onClick={resetItems} className="btn-maintain">
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            {t('button.RESET SEARCH')}
                                        </Button>
                                    </Col>
                                    <Col className="text-right">
                                        <Button variant="primary" onClick={AddSkuClick}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            {t('button.SEARCH')}
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        }

                        {isBulkPreview ?
                            <Col sm={12} xxl={{ span: 2, offset: 10 }} className="text-right">
                                <Button variant="primary" onClick={handleCheckAvailability}>
                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                    </svg>
                                    CHECK AVAILABILITY
                                </Button>
                            </Col>
                            : localFromImport ?
                                <Col sm={12} xxl={{ span: 2, offset: 10 }} className="text-right">
                                    <Button
                                        variant="primary"
                                        onClick={handleSubmit}
                                        disabled={isBulkProcessing || !ShowAddToOrder}
                                    >
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        {t('button.ADD TO ORDER')}
                                    </Button>
                                </Col>
                                : ShowAddToOrder ?
                                    <Col sm={12} xxl={!localFromImport ? { span: 2, offset: 7 } : { span: 2, offset: 10 }} className="text-right">
                                        <Button variant="primary" onClick={handleSubmit}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            {t('button.ADD TO ORDER')}
                                        </Button>
                                    </Col>
                                    :
                                    <Col xxl={9} xs={1}></Col>
                        }
                    </Row>
                </Modal.Footer>
            </Modal>

            <Modal show={showModelModal} onHide={handleModelModalClose} backdrop="static" centered dialogClassName="dealer-section model-window">
                <Modal.Header closeButton style={{ justifyContent: 'center' }}>
                    <Modal.Title>{t('popup.MODELS')}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    {!Models ?
                        <PulseLoader color="#66cc33" size="20px" margin="12px" className="mt-5" />
                        :
                        <Table bordered hover striped>
                            <thead>
                                <tr>
                                    <td colSpan="3">{SelectedItemForModels && SelectedItemForModels.itemNum}, {SelectedItemForModels && SelectedItemForModels.itemName}</td>
                                </tr>
                                {Models.length > 0 &&
                                    <tr>
                                        <td colSpan="3">{t('popup.This item fits the following models')}:</td>
                                    </tr>
                                }
                            </thead>
                            <tbody>
                                {Models.length > 0 ? Models.map((d) =>
                                    <>
                                        {d.models.map((m) =>
                                            <tr>
                                                <td>{m.year}</td>
                                                <td>{m.label}</td>
                                                <td>{m.value}</td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </>

                                ) :
                                    <tr>This item has no model restrictions.</tr>
                                }
                            </tbody>
                        </Table>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModelModalClose}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        {t('button.CLOSE')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ItemInquiry;
